<be-dialog-shell [title]="title" (close)="closeDialog()" [closeButton]="!saving"
                 [showFooter]="showSaveAndCancelButtons" [className]="tags.size > 1 ? 'fixed-size' : null">
    <form autocomplete="off" (submit)="$event.preventDefault();" [formGroup]="formGroup">
        <mat-tab-group *ngIf="tags.size > 1">
            <mat-tab *ngFor="let tag of tags" [label]="tag">
                <div class="tab-content">
                    <be-edition-tab
                        *ngIf="['Principal', 'Teléfonos', 'Comercial asociado', 'Usuario'].includes(tag)"
                        [propertiesToShow]="colsForTag(tag)" [formGroup]="formGroup"
                        [formManager]="formManager"
                        [cien]="tag !== 'Principal'"></be-edition-tab>

                    <ng-container *ngIf="['Direcciones'].includes(tag)">
                        <be-edition-tab [propertiesToShow]="colsForTag(tag)" [formGroup]="formGroup"
                                        [formManager]="formManager" [cien]="true"></be-edition-tab>

                        <button mat-flat-button color="primary"
                                *ngIf="mostrarBotonDireccionesIguales()"
                                (click)="direccionesIguales()"
                                [disabled]="modified && !formGroup.valid">Las dos direcciones son iguales
                        </button>
                    </ng-container>

                    <ng-container *ngIf="['Descuentos'].includes(tag)">
                        <be-edition-row [class]="'dialog-row cien'"
                                        [property]="prop('descuentosMetodoFabricacion')" [formGroup]="formGroup"
                                        [formManager]="formManager">
                        </be-edition-row>
                        <be-edition-row [class]="'dialog-row cien'"
                                        [property]="prop('descuentosGenerales')" [formGroup]="formGroup"
                                        [formManager]="formManager">
                        </be-edition-row>

                        <div class="aviso">
                            <mat-icon aria-hidden="true">info</mat-icon>
                            Los descuentos por método de fabricación se aplicarán a la hora de confirmar un pedido,
                            según el
                            método de fabricación seleccionado.
                        </div>

                        <div class="aviso">
                            <mat-icon aria-hidden="true">info</mat-icon>
                            Los descuentos genéricos en facturación se aplicarán a la hora de facturar a un cliente.
                        </div>

                    </ng-container>

                    <ng-container *ngIf="['Facturación'].includes(tag)">
                        <be-edition-row [class]="'dialog-row cien'"
                                        [property]="prop('facturaSimplificada')" [formGroup]="formGroup"
                                        [formManager]="formManager">
                        </be-edition-row>

                        <be-edition-row [class]="'dialog-row cien'"
                                        [property]="prop('diaMesParaCargo')" [formGroup]="formGroup"
                                        [formManager]="formManager">
                        </be-edition-row>

                        <be-edition-row [class]="'dialog-row cien'"
                                        [property]="prop('cuentasBancariasCliente')" [formGroup]="formGroup"
                                        [formManager]="formManager">
                        </be-edition-row>

                        <be-edition-row [class]="'dialog-row cien'"
                                        [property]="prop('formasPagoDisponibles')" [formGroup]="formGroup"
                                        [formManager]="formManager" [filters]="clienteFilter">
                        </be-edition-row>

                        <div class="boton-mandato">
                            <button mat-flat-button (click)="generarMandato()"
                                    [class]="model.mandato ? 'creado' : 'no-creado'">
                                <mat-icon>receipt</mat-icon>
                                Mandato SEPA
                            </button>
                        </div>

                    </ng-container>
                </div>
            </mat-tab>
        </mat-tab-group>
        <be-edition-tab *ngIf="tags.size <= 1"
                        [propertiesToShow]="colsToShow" [formGroup]="formGroup"
                        [formManager]="formManager"></be-edition-tab>
    </form>
    <dialog-actions>
        <button mat-button class="btn_cancelar" (click)="closeDialog()" [disabled]="saving">Cancelar</button>
        <button mat-flat-button class="btn_guardar" *ngIf="shouldManageSaving && modified" (click)="acceptDialog()"
                color="primary"
                [disabled]="!formGroup.valid || !nombreORazonSocialValidos || saving">
            <mat-icon>save</mat-icon>
            Guardar
        </button>
        <button mat-button *ngIf="!(shouldManageSaving && modified)" (click)="acceptDialog()"
                [disabled]="modified && (!formGroup.valid || !nombreORazonSocialValidos)">Aceptar
        </button>
    </dialog-actions>
</be-dialog-shell>
